import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

// Kitchen readability: A / A / A control, persisted. Scales the root font size
// so every rem-based measurement grows with it.
export type FontSize = 'md' | 'lg' | 'xl';
const SIZES: Record<FontSize, string> = { md: '16px', lg: '18px', xl: '20px' };
const KEY = 'cookbook-font-size';

const Ctx = createContext<{ size: FontSize; setSize: (s: FontSize) => void }>({
  size: 'md',
  setSize: () => {},
});

export function FontSizeProvider({ children }: { children: ReactNode }) {
  const [size, setSize] = useState<FontSize>(() => {
    const saved = localStorage.getItem(KEY);
    return saved === 'lg' || saved === 'xl' ? saved : 'md';
  });

  useEffect(() => {
    document.documentElement.style.fontSize = SIZES[size];
    localStorage.setItem(KEY, size);
  }, [size]);

  return <Ctx.Provider value={{ size, setSize }}>{children}</Ctx.Provider>;
}

export function useFontSize() {
  return useContext(Ctx);
}
